export const DEFAULT_BANDS = [
  { to: 40, color: "#EF4444" },
  { to: 70, color: "#F59E0B" },
  { to: 100, color: "#16A34A" },
];
export const SERVICE_BANDS = [{ to: 50, color: "#EF4444" }, { to: 80, color: "#F59E0B" }, { to: 100, color: "#16A34A" }];
export const TARGET_BANDS = [{ to: 40, color: "#EF4444" }, { to: 80, color: "#F59E0B" }, { to: 100, color: "#16A34A" }];

/** Half-donut "speedometer" gauge with red/amber/green zone bands + a dark
 * needle pointing at the current value — dark bold center label for
 * guaranteed legibility regardless of which zone the needle sits in. */
export function SpeedGauge({ pct, label, size = 132, stroke = 13, bands = DEFAULT_BANDS, testId = "sc-gauge-conversion" }) {
  const p = Math.max(0, Math.min(100, pct || 0));
  const r = (size - stroke) / 2;
  const cx = size / 2;
  const cy = size / 2;
  const toXY = (deg) => {
    const rad = (deg * Math.PI) / 180;
    return { x: cx + r * Math.cos(rad), y: cy - r * Math.sin(rad) };
  };
  let prevTo = 0;
  const segments = bands.map((z) => {
    const a = toXY(180 - (prevTo / 100) * 180);
    const b = toXY(180 - (z.to / 100) * 180);
    const seg = { d: `M ${a.x} ${a.y} A ${r} ${r} 0 0 1 ${b.x} ${b.y}`, color: z.color };
    prevTo = z.to;
    return seg;
  });
  const needleLen = r * 0.8;
  const needleRad = ((180 - (p / 100) * 180) * Math.PI) / 180;
  const nx = cx + needleLen * Math.cos(needleRad);
  const ny = cy - needleLen * Math.sin(needleRad);
  return (
    <div className="flex flex-col items-center" data-testid={testId}>
      <svg width={size} height={size / 2 + stroke / 2 + 4} viewBox={`0 0 ${size} ${size / 2 + stroke / 2 + 4}`}>
        {segments.map((s, i) => (
          <path key={i} d={s.d} fill="none" stroke={s.color} strokeWidth={stroke} strokeLinecap="butt" opacity={0.88} />
        ))}
        <circle cx={cx} cy={cy} r={5.5} fill="#0F172A" />
        <line x1={cx} y1={cy} x2={nx} y2={ny} stroke="#0F172A" strokeWidth={3} strokeLinecap="round" />
      </svg>
      <div className="font-mono text-2xl font-black text-slate-900 -mt-1">{p}%</div>
      <div className="text-[10px] font-bold uppercase tracking-widest text-slate-500 mt-0.5 text-center px-1 leading-tight">{label}</div>
    </div>
  );
}
